module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/create_demand.323e9c1e.svg";